import DailyDealsCarousel from "../DailyDealsCarousel";

const DealyDealsContent = ({ items }: { items: JSX.Element[] }) => (
	<DailyDealsCarousel>{items}</DailyDealsCarousel>
);

export default DealyDealsContent;
